<header class="header">
  <div class="logo">
    <a routerLink="/">HouseDeal</a>
  </div>

  <nav class="nav-menu">
    <button mat-button [matMenuTriggerFor]="propertyMenu">매물</button>
    <mat-menu #propertyMenu="matMenu" overlapTrigger="false">
      <button mat-menu-item routerLink="/listings">매물 목록</button>
      <button mat-menu-item routerLink="/map">지도 보기</button>
    </mat-menu>
    <button mat-button routerLink="/realestate">부동산 등록</button>
    <button mat-button [matMenuTriggerFor]="serviceMenu">서비스</button>
    <mat-menu #serviceMenu="matMenu" overlapTrigger="false">
      <button mat-menu-item routerLink="/support/faq">자주 하는 질문</button>
      <button mat-menu-item routerLink="/events">이벤트</button>
      <button mat-menu-item routerLink="/support/notice">공지사항</button>
      <button mat-menu-item routerLink="/support/inquiry">1:1문의</button>
      <button mat-menu-item routerLink="/support/bug">오류신고</button>
      <button mat-menu-item routerLink="/support/feature">기능 요청</button>
      <button mat-menu-item routerLink="/about">회사소개</button>
    </mat-menu>
  </nav>

  <div class="actions">
    @if (currentUser$ | async; as user) {
      <span class="username">{{ user.username }}님</span>
      <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="사용자 메뉴" class="user-trigger">
        <mat-icon>account_circle</mat-icon>
      </button>
      <mat-menu #userMenu="matMenu" xPosition="before">
        <button mat-menu-item routerLink="/my">
          <mat-icon>person</mat-icon>
          <span>마이페이지</span>
        </button>
        <button mat-menu-item (click)="signoff()">
          <mat-icon>logout</mat-icon>
          <span>로그아웃</span>
        </button>
      </mat-menu>
    } @else {
      <button mat-button routerLink="/signup">회원가입</button>
      <button mat-button routerLink="/signin">로그인</button>
    }
  </div>
</header>
